// extracted by mini-css-extract-plugin
module.exports = {"subTrigger":"styles_subTrigger__jKXrK"};